import { createAsyncThunk } from "@reduxjs/toolkit";
import doFetch from "../../infrastructure/doFetch";
import { SPINNER_NAMES } from "../../components/organisms/Spinner";

const { UPDATE_USER_PROFILE } = SPINNER_NAMES;

export const updateUserProfile = createAsyncThunk(
  "update-user-profile",
  async ({ id, user, useCache, showSpinner } = {}, args) =>
    doFetch({
      url: `users/${id}`,
      method: "PATCH",
      config: {
        body: JSON.stringify(user),
      },
      useCache,
      showSpinner,
      spinner: UPDATE_USER_PROFILE,
      errorMessage: "Unable to update the user. Please try again later.",
      successMessage: "Successfully updated the user.",
      ...args,
    })
);

export const fetchUserProfileById = createAsyncThunk(
  "fetch-user-profile-by-id",
  async (id, args, { useCache, showSpinner } = {}) =>
    doFetch({
      url: `users/${id}`,
      method: "GET",
      useCache,
      showSpinner,
      errorMessage: "Unable to fetch the user profile. Please try again later.",
      successMessage: "Successfully fetch the user profile.",
      ...args,
    })
);
export const fetchInvitedUsers = createAsyncThunk(
  "fetch-invited-users",
  async (id, args, { useCache, showSpinner } = {}) => {
    return doFetch({
      url: `invited-users/${id}`,
      method: "GET",
      useCache,
      showSpinner,
      errorMessage: "Unable to fetch invited users. Please try again later.",
      successMessage: "Successfully fetched invited users.",
      ...args,
    });
  }
);
